// @flow

import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal, fontBold, fontCondensed } from "@fdr/static-ui/Typography";

const createDot = (top: number, right: number, color: string) =>
  `
        &::before {
        content: "";
        position: absolute;
        top: ${top}px;
        right: ${right}px;
        width: 6px;
        height: 6px;
        background-color: ${color};
        border: 1px solid ${buildColor("white", "100")};
        border-radius: 50%;
     }
`;

const TagIcons = {
  bets: createDot(-2, -1, buildColor("red", "500")),
  promo: createDot(-2, 5, buildColor("yellow", "600")),
  optIn: `
        transform: scaleX(-1);
        ${createDot(-2, 5, buildColor("green", "500"))};
    `
};

export const PanelWrapper = styled.div`
  width: 100%;

  &:hover > div > div:first-child {
    background-color: ${buildColor("grey", "100")};
  }

  &:hover > div > div:nth-child(2) {
    background-color: ${(props) =>
      props.isHighlighted
        ? buildColor("navy", "900")
        : buildColor("grey", "100")};
  }
`;

export const PanelContainer = styled.div`
  min-width: 142px;
  border-radius: 4px;
`;

export const TrackName = styled.span`
  font-family: ${fontBold};
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  font-size: 14px;
  margin-top: 0;
  line-height: 125%;
  text-align: left;
  color: ${({ isHighlighted }) =>
    isHighlighted ? buildColor("white") : buildColor("navy")};
`;

export const MetaDescript = styled.span`
  font-size: 14px;
  font-family: ${fontNormal};
  display: block;
  text-overflow: ellipsis;
  overflow: auto;
  white-space: nowrap;
  line-height: 125%;
  color: ${({ isHighlighted }) =>
    isHighlighted ? buildColor("white") : buildColor("navy")};
`;

export const RaceTitleWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
`;

export const TrackNameWrapper = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: ${fontNormal};
`;

export const RaceNumberWrapper = styled.span`
  align-self: flex-end;
  font-family: ${fontNormal};
`;

export const InformationWrapper = styled(Link)`
  padding: 12px;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: ${({ $isHighlighted }) =>
    $isHighlighted ? buildColor("navy") : buildColor("white", "100")};
`;

export const TagsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  align-items: end;
  min-height: 17px;
`;

export const FooterWrapper = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: ${fontBold};
  font-weight: 500;
  padding: 8px 12px;
  color: ${buildColor("blue")};
  border-top: 1px solid ${buildColor("grey", "L2")};
  background-color: ${buildColor("grey", "000")};
  ${({ $isInline }) =>
    !$isInline &&
    css`
      height: 48px;
    `}
`;

export const FlagWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TagIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  > div {
    margin-left: 8px;
  }
`;

export const TagIcon = styled.div`
  position: relative;
  ${({ size }) =>
    size
      ? css`
          height: ${size}px;
          width: ${size}px;
        `
      : ""};
  ${({ type }) => type && TagIcons[type]}
`;

export const LogoContainer = styled.div`
  position: relative;
  top: 2px;
`;

export const LocationName = styled.span`
  font-family: ${fontCondensed};
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${({ isHighlighted }) =>
    isHighlighted ? buildColor("white") : buildColor("grey", "900")};

  &:not(:first-child) {
    margin-left: 4px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TrackTag = styled.span`
  text-align: right;
  color: ${buildColor("white")};
  background-color: ${buildColor("blue", "D1")};
  font-size: 12px;
  font-family: ${fontCondensed};
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 2px 4px;
  border-radius: 10px;
`;
